import { createContext, useContext, useState} from "react";
export const useTitle = $ => {
    return useContext(TitleContext)
}
export const TitleContext = createContext()
export const TitleProvider = ({children}) =>{  
    const [title, setTitle] = useState("Dashboard");     
    return <TitleContext.Provider value={{title, setTitle}}>
        {children}
    </TitleContext.Provider>
}